import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-regn-count',
  templateUrl: './regn-count.component.html',
  styleUrls: ['./regn-count.component.scss']
})
export class RegnCountComponent implements OnInit {
  courseList: any;
  filteredCourseList: any;
  SearchRegnCountForm: FormGroup
  collegedataList: unknown[];
  filteredListCollege: unknown[];
  RegnCoundatalist: any;
  SessionNo: any;
  table
  count: any;
  constructor(private spinner: NgxSpinnerService, public umsService: UmsService,
    public fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.table = false
    this.SearchRegnCountForm = this.fb.group({
      CoCode: new FormControl(''),
      CgCode: new FormControl(''),
    })

    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.spinner.show();
    }

    this.getCourseData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      // this.spinner.show();
    }
    );
  }

  getCourseData() {
    // this.spinner.show()
    const payload = {};
    this.umsService.fetchCutOffCourse(payload).subscribe(res => {
      if (res.status) {
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCollegeData(CoCode) {
    this.table =false;
    this.collegedataList = [];
    this.filteredListCollege = []
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CgCode'] = '';
    payload['CoStr'] = '';
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.collegedataList = Array.from(
          new Map(res.data.map((item) => [item.CgCode, item])).values()
        );

        this.filteredListCollege = [...this.collegedataList];

      }
      else {
        this.spinner.hide();
        this.collegedataList = [];
        this.filteredListCollege = []
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getRegnCountData() {

    const payload = {};
    payload['CoCode'] = this.SearchRegnCountForm.value.CoCode;
    payload['CgCode'] = this.SearchRegnCountForm.value.CgCode;
    payload['SessionId'] = this.SessionNo;
    this.umsService.getRegnCount(payload).subscribe((res) => {
      if (res.status) {
        this.table = true;
        console.log("reeeeeeeeee count", res.data);
        this.RegnCoundatalist = res.data
        this.count = res.data.length
      }
      else {
        this.spinner.hide();
        this.table = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.table = false;
    })
  }

  download(event: Event) {
    event.preventDefault();
    const payload = {};
    payload['CoCode'] = this.SearchRegnCountForm.value.CoCode;
    payload['CgCode'] = this.SearchRegnCountForm.value.CgCode;
    payload['SessionId'] = this.SessionNo;
    this.umsService.getRegnCount(payload).subscribe((res) => {
      if (res.status) {
        const extractedData = res.data.map(element => ({
          EnrollmentNo: element.FinalRegNo,
          StudentName: element.FullName,
          EmailID: element.StuEmailId,
          MobileNumber: element.StuMobNumber,
          DOB: element.DOB,
          Gender: element.Gender,
          College: element.CgName,
          Course: element.CoName
        }));

        // Convert array data to CSV format
        const csvContent = this.convertArrayToCSV(extractedData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'RegistrationCountReport.csv'; // You can change the file name if needed
        document.body.appendChild(link);

        // Trigger the download
        link.click();
      } else {
      }
    });
  }
  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }

  back(){
    this.SearchRegnCountForm.reset();
    this.table = false
  }
}
